// extracted by mini-css-extract-plugin
module.exports =  {"avatar":"gX7gCWG"};